import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SiteContentService, SiteContentType } from '../services/api.services';
import { catchAppError } from '../shared/utils';
import { SupportLinksContent, SupportLinksDefaultContent } from './content.models';

class ContentState<T> {
  constructor(public type: SiteContentType) { }

  content$ = new BehaviorSubject<T>(null);
  loaded = false;
};

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private contentStates: ContentState<unknown>[] = [];

  constructor(private readonly siteContentService: SiteContentService) { }


  private supportLinks = this.defineContent<SupportLinksContent>(SiteContentType.SupportLinks);

  get supportLinks$() { return this.getOrLoadContent(this.supportLinks); }


  getDefaultContent(type: SiteContentType) {
    switch (type) {
      case SiteContentType.SupportLinks:
        return { ...SupportLinksDefaultContent };
    }

    throw `Unknown content type '${type}'`;
  }

  reload() {
    for (let contentState of this.contentStates) {
      if (contentState.loaded) {
        contentState.loaded = false;

        this.getOrLoadContent(contentState);
      }
    }
  }


  private defineContent<T>(contentType: SiteContentType) {
    let contentState = new ContentState<T>(contentType);

    this.contentStates.push(contentState);

    return contentState;
  }

  private getOrLoadContent<T>(contentState: ContentState<T>) {
    if (!contentState.loaded) {
      contentState.loaded = true;

      this.siteContentService.get(contentState.type).pipe(
        tap(siteContent => {
          let content = siteContent.content ? JSON.parse(siteContent.content) : null;

          contentState.content$.next(content);
        }),
        catchAppError(err => of(false))
      ).subscribe();
    }

    return contentState.content$;
  }
};
